import React from "react";
import {userManager} from "../../managers/UserManager";
import {Subscription} from "./Subscription";
import {i18nFormat} from "../../lib/i18nFormat";
import {EmptyPageContent} from "../../components/EmptyPageContent";

export function SubscriptionsPage() {
  const user = userManager.store(state => state.user); // User is updated on state change.


  if (Object.entries(user.subscriptions).length === 0) {
    return (
      <EmptyPageContent
        glyph={"glyph-core-arrow-double-circular-rotated"}
        title={i18nFormat("subscriptions.no-subscriptions.title")}
        text={i18nFormat("subscriptions.no-subscriptions.description")}
      />
    )
  }

  return (
    <section className="account-page account-subscriptions">
      <header className="account-page__header">
        <h1 className="account-page__title">{i18nFormat("subscriptions.title")}</h1>
        <p className="account-page__text">{i18nFormat("subscriptions.subtitle")}</p>
      </header>
      <div className="account-page__content">
        {Object.entries(user.subscriptions).map(([subscriptionId, subscription]) => (
          <Subscription key={subscriptionId} subscriptionId={subscriptionId} subscription={subscription}/>
        ))}
      </div>
    </section>
  );
}